import { IntlShape } from 'react-intl'

// TYPES & CONSTANTS
import * as messages from './messages'
import { FilterCheckbox } from './types'
import { FiltersWithSelectedStatus } from '../../types'

export const setCheckboxesState = (
  checkboxes: FilterCheckbox[],
  bulkCheckboxState?: boolean
): FilterCheckbox[] =>
  checkboxes.map(checkbox => {
    const { isSelected } = checkbox

    const isCheckboxWithState = bulkCheckboxState ?? isSelected

    return {
      ...checkbox,
      isSelected: isCheckboxWithState
    }
  })

export const renderInfoText = (
  intl: IntlShape,
  isOneOrMoreSelected: boolean,
  areAllSelected: boolean,
  infoText: string
) => {
  if (infoText) {
    return infoText
  }

  if (areAllSelected) {
    return intl.formatMessage(messages.AllItemsSelected)
  }

  if (isOneOrMoreSelected) {
    return intl.formatMessage(messages.OneOrMoreItemsSelected)
  }

  return intl.formatMessage(messages.NoItemsSelected)
}

export const getNumberOfSelectedFilters = (
  filters: FiltersWithSelectedStatus<any>[]
) => {
  let result = 0

  filters.forEach(filter => {
    if (!filter.every(({ isSelected }) => isSelected)) {
      result += 1
    }
  })

  return result
}
